<template>
  <div class="page flex-col">
    <JoinUsWidget v-if="select === 0" @select="handleSelect" />
    <!--  团队  -->
    <TeamWidget v-else-if="select === 1" @select="handleSelect" />
    <!--  行业分析  -->
    <IndustryAnalysisWidget v-else-if="select === 2" @select="handleSelect" />
    <!--  竞品分析  -->
    <CompetitiveAnalysisWidget v-else-if="select === 3" @select="handleSelect" />
    <!--  产品与服务  -->
    <ProductsAndServicesWidget v-else-if="select === 4" @select="handleSelect" />
    <!--  运营规划  -->
    <OperationalPlanningWidget v-else-if="select === 5" @select="handleSelect" />
    <!--  销售渠道  -->
    <DistributionChannelWidget v-else-if="select === 6" @select="handleSelect" />
  </div>
</template>
<script>
import TeamWidget from '@/views/join_us/components/Team/index.vue'
import IndustryAnalysisWidget from '@/views/join_us/components/IndustryAnalysis/index.vue'
import CompetitiveAnalysisWidget from '@/views/join_us/components/CompetitiveAnalysis/index.vue'
import ProductsAndServicesWidget from '@/views/join_us/components/ProductsAndServices/index.vue'
import OperationalPlanningWidget from '@/views/join_us/components/OperationalPlanning/index.vue'
import DistributionChannelWidget from '@/views/join_us/components/DistributionChannel/index.vue'
import JoinUsWidget from '@/views/join_us/components/JoinUsWidget.vue'

export default {
  components: {
    JoinUsWidget,
    TeamWidget,
    IndustryAnalysisWidget,
    CompetitiveAnalysisWidget,
    ProductsAndServicesWidget,
    OperationalPlanningWidget,
    DistributionChannelWidget,
  },
  data() {
    return {
      select: 0,
      constants: {}
    };
  },
  mounted() {
    if (this.$route.query?.top) {
      const top = Number(this.$route.query?.top);
      switch (top) {
        case 1:
          return window.scrollTo(0, window.innerWidth/4.3); // 500
        case 2:
          return window.scrollTo(0, window.innerWidth/1.97); // 1050
        case 3:
          return window.scrollTo(0, window.innerWidth/1.26); // 1600
        case 4:
          return window.scrollTo(0, window.innerWidth/0.84); // 2400
        default:
          return window.scrollTo(0, 0);
      }
    }
  },
  methods: {
    handleSelect(value, top = false) {
      this.select = value;
      const height = window.innerWidth/1.83
      if (top) {
        return window.scrollTo(0,0);
      }
      if (value === 0) {
        return setTimeout(() => {
          window.scrollTo(0, Number(height))
        }, 1); // 1050
      }
      window.scrollTo(0,0);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
